/** Somalia - display +252… (no leading 0); E.164 for tel / WhatsApp */
export const PHONE_PRIMARY = {
  display: '+252 63 4888780',
  tel: '+252634888780',
  whatsappDigits: '252634888780',
};

/** WhatsApp for package orders and chat (wa.me links) */
export const WHATSAPP_CONTACT = {
  display: '+252 63 4399993',
  whatsappDigits: '252634399993',
};

export const PHONE_SECONDARY = {
  display: '+252 63 4399993',
  tel: '+252634399993',
  whatsappDigits: '252634399993',
};

export const SOCIAL_LINKS = [
  {
    key: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/Hitdesigns01',
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    href: 'https://www.tiktok.com/@hitdesigns01',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/hitdesigs',
  },
];
